// "Baixe o app" section on the landing page. Painel Admin > Configurações >
// Página inicial turns each store on or off in app_settings/mobileApps, so the Play link can
// go live the day Google approves the app, without a deploy. Nothing shows
// while both are off.
import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export const MOBILE_APPS_DOC = ['app_settings', 'mobileApps'];
export const PLAY_URL_DEFAULT = 'https://play.google.com/store/apps/details?id=digital.escambo';
export const STORE_URL_PREFIX = {
    android: 'https://play.google.com/',
    ios: 'https://apps.apple.com/',
};

// Only links to the stores themselves are rendered.
export const validStoreUrl = (store, url) =>
    typeof url === 'string' && url.startsWith(STORE_URL_PREFIX[store]);

const StoreButton = ({ href, small, big }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex flex-col items-start bg-black text-white rounded-lg px-5 py-2 min-w-[180px] hover:bg-gray-800 transition"
    >
        <span className="text-xs uppercase tracking-wide">{small}</span>
        <span className="text-xl font-semibold leading-tight">{big}</span>
    </a>
);

export default function AppStoreLinks() {
    const [apps, setApps] = useState(null);

    useEffect(() => {
        if (!db) return undefined;
        return onSnapshot(doc(db, ...MOBILE_APPS_DOC),
            (snap) => setApps(snap.exists() ? snap.data() : null),
            () => setApps(null));
    }, []);

    const android = apps?.android?.show && validStoreUrl('android', apps.android.url) ? apps.android.url : null;
    const ios = apps?.ios?.show && validStoreUrl('ios', apps.ios.url) ? apps.ios.url : null;
    if (!android && !ios) return null;

    return (
        <section className="py-12 bg-white">
            <div className="container mx-auto px-6 text-center">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800">Baixe o app Escambo Digital</h2>
                <p className="text-gray-600 mt-2">Anuncie, converse e acompanhe suas trocas pelo celular.</p>
                <div className="mt-6 flex flex-wrap justify-center gap-4">
                    {android && <StoreButton href={android} small="Disponível no" big="Google Play" />}
                    {ios && <StoreButton href={ios} small="Baixar na" big="App Store" />}
                </div>
            </div>
        </section>
    );
}
